<template>
    <Layout>
        <PageHeader :title="title" />
        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <div>
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row g-4">
                                <div class="col-sm">
                                    <div class="d-flex justify-content-sm-end">
                                        <div class="search-box ms-2" v-if="productsData.length">
                                            <input type="text" @keyup.prevent="searchForm" class="form-control" placeholder="جستجوی محصول" v-model="search_key"/>
                                            <i class="ri-search-line search-icon"></i>
                                        </div>
                                        <Skeletor class="search-box ms-2" style="width: 200px;height: 30px" v-else></Skeletor>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-header">
                            <div class="row align-items-center">
                                <div class="col">
                                    <ul class="nav nav-tabs-custom card-header-tabs border-bottom-0" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active fw-semibold" data-bs-toggle="tab" href="#productnav-all" role="tab">
                                                همه محصولات
                                                <span class="badge badge-soft-danger align-middle rounded-pill ms-1">{{productsData.length}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- end card header -->
                        <div class="card-body">
                            <div class="tab-content text-muted">
                                <div
                                    class="tab-pane active"
                                    id="productnav-all"
                                    role="tabpanel"
                                >
                                    <div
                                        id="table-product-list-all"
                                        class="table-card gridjs-border-none"
                                    >
                                        <ProductList v-if="productsData.length" :resultQuery="resultQuery" />
                                        <ProductListSkeleton v-else />

                                        <div class="d-flex justify-content-end m-3">
                                            <div class="pagination-wrap hstack gap-2">
                                                <a
                                                    class="page-item pagination-prev disabled"
                                                    href="#"
                                                    v-if="page != 1"
                                                    @click="page--"
                                                >
                                                    صفحه قبل
                                                </a>
                                                <ul class="pagination listjs-pagination mb-0">
                                                    <li
                                                        v-for="(pageNumber, index) in pages.slice(
                              page - 1,
                              page + 5
                            )"
                                                        :key="index"
                                                        @click="page = pageNumber"
                                                        :class="{
                              active: pageNumber == page,
                              disabled: pageNumber == '...',
                            }"
                                                    >
                                                        <a class="page" href="#">{{ pageNumber }}</a>
                                                    </li>
                                                </ul>
                                                <a
                                                    class="page-item pagination-next"
                                                    href="#"
                                                    @click="page++"
                                                    v-if="page < pages.length"
                                                >
                                                    صفحه بعد
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- end tab pane -->

                                <div class="tab-pane" id="productnav-published" role="tabpanel">
                                    <div
                                        id="table-product-list-published"
                                        class="table-card gridjs-border-none"
                                    ></div>
                                </div>
                                <!-- end tab pane -->

                                <div class="tab-pane" id="productnav-draft" role="tabpanel">
                                    <div class="py-4 text-center">
                                        <div>
                                            <lottie
                                                class="avatar-xl"
                                                colors="primary:#121331,secondary:#08a88a"
                                                :options="defaultOptions"
                                                :height="75"
                                                :width="75"
                                            />
                                        </div>

                                        <div class="mt-4">
                                            <h5>Sorry! No Result Found</h5>
                                        </div>
                                    </div>
                                </div>
                                <!-- end tab pane -->
                            </div>
                            <!-- end tab content -->
                        </div>
                        <!-- end card body -->
                    </div>
                    <!-- end card -->
                </div>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>
<script>

import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";
import PageHeader from "@/components/page-header";
import animationData from "@/components/widgets/msoeawqm.json";
import Lottie from "@/components/widgets/lottie.vue";
import axios from "axios";

import ProductList from "./product/product-list";
import ProductListSkeleton from "./product/product-list-skeleton";

import { Skeletor } from "vue-skeletor";
export default {
    page: {
        title: "محصولات",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "محصولات",
            searchQuery: null,
            defaultOptions: { animationData: animationData },
            productsData: [],
            pages: [],
            page: 1,
            perPage: 10,
            search_key: '',
        };
    },
    computed: {
        displayedPosts() {
            return this.paginate(this.productsData);
        },
        resultQuery() {
            if (this.searchQuery) {
                const search = this.searchQuery.toLowerCase();
                return this.displayedPosts.filter((data) => {
                    return (
                        data.name.includes(search) ||
                        data.stock_status.includes(search)
                    );
                });
            } else {
                return this.displayedPosts;
            }
        },
    },
    watch: {
        productsData(newValue) {
            this.setPages(newValue);
        },
        resultQuery() {
            if (this.searchQuery) this.setPages(this.displayedPosts);
            else this.setPages(this.productsData);
        },
    },
    created() {
        this.setPages(this.productsData);
        this.fetchProducts()
    },
    filters: {
        trimWords(value) {
            return value.split(" ").splice(0, 20).join(" ") + "...";
        },
    },
    methods: {
        fetchProducts() {
            this.$Progress.start();
            return new Promise((resolve, reject) => {
                axios.get('/branch/product/list')
                    .then((response) => {
                        const {data} = response;
                        this.productsData = data;
                        resolve(response);
                        this.$Progress.finish();
                    }, (error) => {
                        reject(error);
                        this.$Progress.fail();
                    });
            });
        },
        setPages(data) {
            this.pages = [];
            let numberOfPages = Math.ceil(data.length / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },
        paginate(productsData) {
            let page = this.page;
            let perPage = this.perPage;
            let from = page * perPage - perPage;
            let to = page * perPage;
            return productsData.slice(from, to);
        },
        searchForm(e) {
            let value = e.target.value;
            this.searchQuery = value;
        }
    },
    components: {
        Layout,
        PageHeader,
        lottie: Lottie,
        ProductList,
        ProductListSkeleton,
        Skeletor
    },
};
</script>

